import { type FC, useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { Button } from "@/shared/components/ui/button";
import { usePerson } from "@/shared/hooks/useAppContext";
import { getFirstName } from "@/shared/utils/names";
import checkAnimation from "@/shared/assets/animations/Check confetti.lottie?url";
import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

export const GreatStart: FC<FlowCustomComponentProps> = ({ onComplete }) => {
  const person = usePerson();
  const firstName = getFirstName(person?.full_name || "");
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col items-center">
      <div className="h-52 w-52">
        <DotLottieReact
          src={checkAnimation}
          loop={false}
          autoplay
          speed={2}
          renderConfig={{ devicePixelRatio: 2 }}
        />
      </div>
      <div
        className={`mt-1 text-center transition-opacity duration-500 ${showContent ? "opacity-100" : "opacity-0"}`}
      >
        <h2>You're verified and ready to go!</h2>
        <p className="mt-4 text-base text-secondary text-pretty">
          {firstName}'s information is saved and will carry forward through every step. You won't
          need to enter it again.
        </p>
      </div>
      <div
        className={`mt-10 w-full transition-opacity duration-500 ${showContent ? "opacity-100" : "opacity-0"}`}
      >
        <Button variant="brand" rounded className="w-full" onClick={() => onComplete()}>
          Continue <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
